module.exports = __webpack_public_path__ + "img/default-banner.d484284d.png";